import React, { useState, useEffect } from "react";
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';

const Carousel = ({ images }) => {
    const [imageIndex, setImageIndex] = useState(0);

    const nextImage = () => {
        setImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevImage = () => {
        setImageIndex(
            (prevIndex) => (prevIndex - 1 + images.length) % images.length
        );
    };

    useEffect(() => {
        if (!images || images.length <= 1) return;

        const interval = setInterval(() => {
            nextImage();
        }, 5000); // Change image every 2 seconds

        return () => clearInterval(interval); // Cleanup interval on component unmount
    }, [images, images?.length]);

    if (!images || images.length === 0) return null;

    return (
        <div className="flex flex-col items-center justify-center my-4 w-full">
            <div className="flex justify-center items-center gap-2 md:gap-4 w-full">
                <button className="text-xs md:text-base text-white cursor-pointer hover:opacity-80 transition-opacity flex-shrink-0" onClick={prevImage}>
                    <HiChevronLeft className="w-8 h-8 md:w-10 md:h-10" />
                </button>

                <div className="w-[85vw] md:w-[60vw] lg:w-[40vw] px-2 md:px-4 pt-2 md:pt-4 max-w-5xl bg-black rounded-2xl flex flex-col border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                    <div className="flex justify-center items-center w-full aspect-video rounded-xl overflow-hidden relative">
                        {images.map((item, index) => (
                            <div
                                key={index}
                                className={`absolute inset-0 transition-opacity duration-500 bg-black ${index === imageIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
                            >
                                {typeof item === 'string' ? (
                                    <img
                                        src={item}
                                        alt="Slideshow"
                                        className="w-full h-full object-contain"
                                    />
                                ) : (
                                    // Render the custom element (like an iframe structure)
                                    <div className="w-full h-full overflow-hidden">
                                        {item}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className="flex justify-center items-center gap-4 py-4 mb-2">
                        <div className="bg-white rounded-full w-5 h-5 md:w-10 md:h-10 lg:w-12 lg:h-12 border-2 border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]"></div>
                        <div className="bg-white rounded-full w-5 h-5 md:w-10 md:h-10 lg:w-12 lg:h-12 border-2 border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]"></div>
                        <div className="bg-white rounded-full w-5 h-5 md:w-10 md:h-10 lg:w-12 lg:h-12 border-2 border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]"></div>
                        <div className="bg-red-600 rounded-full w-5 h-5 md:w-10 md:h-10 lg:w-12 lg:h-12 border-2 border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]"></div>
                    </div>
                </div>

                <button className="text-xs md:text-base text-white cursor-pointer hover:opacity-80 transition-opacity flex-shrink-0" onClick={nextImage}>
                    <HiChevronRight className="w-8 h-8 md:w-10 md:h-10" />
                </button>
            </div>
        </div>
    );
};

export default Carousel;
